(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/map-interval.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/map-interval.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useState = _React.useState;
const getIntervalResultMapHandler = svs.lyckoplatsen.components.shared_map.getIntervalResultMapHandler;
const getHomeLocationCoordinates = svs.tur.lyckoplatsen.map.getHomeLocationCoordinates;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  overlayResultAtom = _svs$lyckoplatsen$com.overlayResultAtom,
  showHomeLocationPinAtom = _svs$lyckoplatsen$com.showHomeLocationPinAtom;
const memoFetchResult = svs.lyckoplatsen.utils.page_result.memoFetchResult;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const mapErrorDialogNoRedirect = svs.lyckoplatsen.shared_map.utils.mapErrorDialogNoRedirect;
const Button = svs.ui.ReactButton;
const mapId = 'map-interval';
const MapInterval = _ref => {
  let results = _ref.results;
  const mapHandlerResult = useMemo(() => getIntervalResultMapHandler(), []);
  const intervalResults = results;
  const setOverlayResult = useSetAtom(overlayResultAtom);
  const showHomeLocationPin = useAtomValue(showHomeLocationPinAtom);
  const setShowHomeLocationPin = useSetAtom(showHomeLocationPinAtom);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showCenterMapButton = _useState2[0],
    setShowCenterMapButton = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mapReady = _useState4[0],
    setMapReady = _useState4[1];
  const hasHomeLocation = useMemo(() => Boolean(getHomeLocationCoordinates()), []);
  const handleCenterMapClick = () => {
    mapHandlerResult.centerMap();
  };
  const handleHomeLocationClick = () => {
    if (showHomeLocationPin) {
      setShowHomeLocationPin(false);
      mapHandlerResult.removeHomeLocation();
      return;
    }
    setShowHomeLocationPin(true);
    mapHandlerResult.showHomeLocation();
  };

  useEffect(() => {
    const mapOptions = {
      nodeId: mapId,
      maxBounds: [[72.1, -5.5], [47.1, 39.5]],
      maxZoom: 15,
      minZoom: 4,
      zoomSnap: 0.25,
      dragging: true,
      boxZoom: true,
      touchZoom: true,
      errorCallback: mapErrorDialogNoRedirect
    };
    const evtHandlers = {
      intervalPinClicked: async _ref2 => {
        let productId = _ref2.productId,
          drawNumber = _ref2.drawNumber;
        const result = await memoFetchResult(productId, drawNumber);
        setOverlayResult(result);
      },
      showCenterMapButton: bool => setShowCenterMapButton(bool)
    };
    mapHandlerResult.createMap({
      mapOptions,
      evtHandlers
    });
    mapHandlerResult.fitBoundsSweden();
    setMapReady(true);
    return () => {
      setMapReady(false);
      mapHandlerResult.removeMap();
    };
  }, [mapHandlerResult, setOverlayResult]);
  useEffect(() => {
    if (!mapReady) {
      return;
    }
    if (showHomeLocationPin) {
      mapHandlerResult.showHomeLocation({
        panToLocation: false
      });
    } else {
      mapHandlerResult.removeHomeLocation();
    }
  }, [mapHandlerResult, mapReady, showHomeLocationPin, intervalResults]);
  useEffect(() => {
    if (intervalResults !== null && intervalResults !== void 0 && intervalResults.length) {
      mapHandlerResult.centerMap();
      mapHandlerResult.showIntervalResult(intervalResults);
      return () => mapHandlerResult.removeIntervalResult();
    }
  }, [mapHandlerResult, intervalResults]);
  return React.createElement("div", {
    className: "result-map result-map-interval lp-result-details"
  }, React.createElement("div", {
    id: mapId,
    style: {
      height: '100%',
      width: '100%'
    }
  }), React.createElement(Button, {
    disabled: !showCenterMapButton,
    className: "lp-btn-center-map ".concat(showCenterMapButton ? '' : 'disable'),
    onClick: handleCenterMapClick
  }, React.createElement("svg", {
    fill: "#fff",
    viewBox: "0 0 112 260",
    enableBackground: "new 0 0 112 260",
    xmlSpace: "preserve",
    role: "img",
    "aria-labelledby": "center-map-icon-title"
  }, React.createElement("title", {
    id: "center-map-icon-title"
  }, "Knappen: Visa hela Sverige"), React.createElement("polygon", {
    points: "109.627,57.925 104.224,46.74 105.859,39.394 95.337,12.782 88.204,10.294 79.555,2 75.692,3.421 73.773,14.085 61.474,11.431 47.872,32.711 50.099,39.583 43.346,52.711 36.308,57.001 34.53,75.864 28.891,85.698 31.094,96.456 20.739,97.191 14.506,109.395 16.426,128.495 14.648,138.661 20.762,145.486 16.592,168.756 8.321,178.827 9.293,184.681 2.373,189.562 2.61,200.179 8.866,203.923 8.843,215.795 18.203,236.838 18.345,255.511 21.497,258 33.037,254.872 35.123,245.014 48.654,244.35 56.758,218.354 57.114,196.648 72.517,186.6 76.617,174.941 66.545,159.609 61.569,159.348 58.607,144.964 61.593,130.888 61.829,125.248 75.811,105.627 87.304,97.001 92.304,86.267 91.593,74.086 96.024,58.636 "
  }))), hasHomeLocation && React.createElement(Button, {
    className: "lp-btn-home-location",
    onClick: handleHomeLocationClick,
    "aria-pressed": showHomeLocationPin,
    "aria-label": "Visa hemadress"
  }, React.createElement("img", {
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/lyckoplatsen/hemma.svg"),
    alt: ""
  })));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  MapInterval
});

 })(window);